import * as React from "react";
import "./IronImage.css";

interface IProps {
  src: string;
  className?: string | undefined;
  title: string;
  placeholder: string;
}

interface IState {
  loaded?: boolean | undefined;
}

//The purpose of this component is to show a blurred preloaded image in the jumbotron while it is loading the full image
class IronImage extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { loaded: false };
  }

  componentDidMount() {
    const hdLoaderImg = new Image();

    hdLoaderImg.src = this.props.src;

    hdLoaderImg.onload = () => {
      this.setState({ loaded: true });
    };
  }

  render() {
    let style = {
      backgroundImage: `url('${this.props.src}')`,
    };
    return (
      <div className="iron-image-container">
        <div
          className={`${this.state.loaded ? "iron-image-fade-in" : ""} iron-image-loaded ${this.props.className ?? ""}`}
          style={this.state.loaded ? style : undefined}
        >
          <div className="title">
            <h3>{this.props.title}</h3>
          </div>
        </div>
        <div className={`${this.props.className ?? ""} iron-image-preload`} style={{ backgroundImage: `url("${this.props.placeholder}")` }}></div>
      </div>
    );
  }
}

export default IronImage;
